module.exports = __webpack_public_path__ + "img/2010 winteressen 018.d6cc8a88.jpg";